import { SxProps, Theme } from '@mui/material/styles';

export const BazaarVoiceWidgetSx: Record<string, SxProps<Theme>> = {
	accordionSummary: {
		p: { sm: '10px', md: '0' },
		'& .MuiAccordionSummary-content': {
			margin: 0,
		},
		'&.MuiAccordionSummary-gutters': {
			paddingLeft: 0,
			paddingRight: 0,
		},
	},
	accordionHeader: {
		flexDirection: { sm: 'column', md: 'row' },
		gap: '10px',
		alignItems: 'baseline',
	},
	accordionTitle: {
		color: 'grey.500',
	},
	accordionLink: { color: 'secondary.light' },
	accordionContainer: {
		height: 'auto',
		maxWidth: '100%',
		backgroundColor: 'background.paper',
	},
	accordionDetails: { p: 0 },
	ratingSummaryContent: {
		'[data-bv-show="rating_summary"]': {
			'.bv_main_container': {
				'.bv_main_container_row_flex': {
					'.bv_main_container_row_flex:nth-of-type(2)': {
						display: 'none !important',
					},
				},
			},
		},
	},
	askAQuestionContent: {
		'[data-bv-show="rating_summary"]': {
			'> .bv_main_container': {
				'> .bv_main_container_row_flex .bv_main_container_row_flex:first-of-type': {
					display: 'none !important',
				},
			},
			'.bv_main_container_row_flex.bv_ratings_summary.bv_main_rating_button': {
				display: 'none !important',
			},
		},
	},
};
